
import { useState } from "react";
import { Dialog } from 'primereact/dialog';
import IngresoReporte from "../../componentes/IngresosReportes/IngresosReportes";
import { PERMISOS, puedeAcceder } from "../../servicios/sesionSeguridad";

export default function IngresosReporte() {
  const [Visible, setVisible] = useState(false);
  const Cargar = () => { }
  if (!puedeAcceder(PERMISOS.REPORTES_VER)) return null;
  return (
    <div>
      <button className="reportes-contenedor" title="Reportes" onClick={() => setVisible(true)}>
        <i className="pi pi-chart-bar" aria-hidden="true" /><span>Reportes</span>
      </button>

      <Dialog header={<h3>Reporte Ingresos</h3>} position='center' visible={Visible}
        style={{ width: '80vw', height: '80vh' }} maximizable={true}
        contentStyle={{ backgroundColor: "white" }}
        closable={true}
        onShow={Cargar}
        onHide={() => setVisible(false)} >
        <IngresoReporte />
      </Dialog>

    </div>
  )
}
